import { render, staticRenderFns } from "./Knows.vue?vue&type=template&id=6238be40&scoped=true&"
import script from "./Knows.vue?vue&type=script&lang=js&"
export * from "./Knows.vue?vue&type=script&lang=js&"
import style0 from "./Knows.vue?vue&type=style&index=0&id=6238be40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6238be40",
  null
  
)

export default component.exports